import { useQuery } from "@apollo/client";
import { Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import moment from "moment";
import { useEffect, useState } from "react";
import "../../App.css";
import { GET_MONTLY_MATERIAL_USING_REPORT } from "../../Schema/Report";
import { EmptyTr } from "../Include/EmptyData";
import { LoadingTr } from "../Include/LoadingPage";

export default function BuyProductReport({
  startDate,
  endDate,
  categoryId,
  meterialId,
  sectionListId,
  levelSectionListId,
  sizeListId,
  warehouseValId,
  isHaveStock,
}) {
  const [tableData, setTableData] = useState([]);
  const [total, setTotal] = useState(null);
  const [loading, setLoading] = useState(true);

  // console.log("categoryId:::", categoryId);

  const { refetch } = useQuery(GET_MONTLY_MATERIAL_USING_REPORT, {
    variables: {
      from: startDate ? dayjs(startDate)?.format("YYYY-MM-DD") : "",
      to: endDate ? dayjs(endDate)?.format("YYYY-MM-DD") : "",
      isHaveStock:
        isHaveStock === "all"
          ? null
          : isHaveStock === "haveStock"
            ? true
            : false,
      warehouseIds: warehouseValId ? [warehouseValId] : [],
      materialIds: meterialId ? meterialId : [],
      sectionIds: sectionListId ? sectionListId : [],
      sizeIds: sizeListId ? sizeListId : [],
      levelSectionIds: levelSectionListId ? levelSectionListId : [],
      categoryIds: categoryId ? categoryId : [],
    },
    onCompleted: ({ getMonthlyMaterialUsingReport }) => {
      // console.log(
      //   "getMonthlyMaterialUsingReport:::",
      //   getMonthlyMaterialUsingReport,
      // );
      setTableData(getMonthlyMaterialUsingReport);

      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::getMonthlyMaterialUsingReport", err?.message);
    },
  });

  useEffect(() => {
    setLoading(true);
    refetch();
  }, [
    startDate,
    endDate,
    categoryId,
    meterialId,
    warehouseValId,
    sectionListId,
    levelSectionListId,
    isHaveStock,
    sizeListId,
  ]);

  return (
    <>
      <Stack
        direction="column"
        justifyContent="center"
        alignItems="center"
        marginTop="25px"
      >
        <Typography className="report-title-kh">ទិញទំនិញប្រចាំខែ</Typography>
        <Typography className="report-title-en">
          {`${moment(startDate)?.format("DD-MM-YYYY")} - ${moment(endDate)?.format("DD-MM-YYYY")}`}
        </Typography>
      </Stack>
      <div className="report-table-scroll-container">
        <table className="report-table">
          <tbody>
            <tr>
              <td className="report-table-th-sticky" align="center" width="10%">
                ប្រភេទ
              </td>
              <td className="report-table-th-sticky" align="center" width="10%">
                កាលបរិច្ឆេទ
              </td>
              <td className="report-table-th-sticky" align="center" width="10%">
                ម៉ោង
              </td>
              <td className="report-table-th-sticky" align="center" width="10%">
                ឃ្លាំង
              </td>
              <td className="report-table-th-sticky" align="center" width="10%">
                បរិយាយ
              </td>
              <td className="report-table-th-sticky" align="center" width="10%">
                មូលហេតុ
              </td>
              <td className="report-table-th-sticky" align="center" width="10%">
                បរិមាណ
              </td>
              <td className="report-table-th-sticky" align="center" width="10%">
                តម្លៃរាយ
              </td>
              <td
                className="report-table-th-sticky"
                align="center"
                width="10% "
              >
                តម្លៃសរុប
              </td>
            </tr>
          </tbody>

          <tbody className="report-table-body">
            {loading ? (
              <LoadingTr colSpan={9} />
            ) : !tableData?.length ? (
              <EmptyTr colSpan={9} />
            ) : (
              tableData?.map((row, index) => {
                return (
                  <tr key={index}>
                    <td className="report-table-body-td-center">{index + 1}</td>

                    <td className="report-table-body-td-center">
                      {moment(row?.createdAt)?.format("DD-MM-YYYY hh:mm a")}
                    </td>

                    <td className="report-table-body-td-center">
                      {row?.adjustOutId?.warehouseId?.warehouseName}
                    </td>

                    <td className="report-table-body-td-left">
                      {row?.listMaterialUnitId?.materialId?.materialKhName}
                    </td>

                    <td className="report-table-body-td-center">
                      {/* {adjustOutReason(row?.adjustOutId?.reason)} */}
                    </td>

                    <td className="report-table-body-td-center">
                      {row?.listMaterialUnitId?.unitId?.unitKhName}
                    </td>

                    <td className="report-table-body-td-center">{row?.qty}</td>
                    <td className="report-table-body-td-center">{row?.qty}</td>
                    <td className="report-table-body-td-center">{row?.qty}</td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}
